// 美居社区化
import fetch from '../fetch';

import {
  // 账号管理
  QRY_SOCIAL_ACCOUNT_LIST,
  SOCIAL_ACCOUNT_ADD_SOCIAL_ACCOUNT,
  UNFORBIDDEN_ACCOUNT,
  FORBIDDEN_ACCOUNT,
  SOCIAL_ACCOUNT_SET_ACCOUNT_TYPE,
  SOCIAL_ACCOUNT_SYNC_ACCOUNT,
  SET_MASTER,
  REMOVE_MASTER,
  EDIT_VEST_ACCOUNT,
  SET_VEST_FANS_BY_UIDS,
  QRY_ACCOUNT_BY_UID,
  // 举报管理
  QRY_SOCIAL_REPORT_LIST,
  QRY_SOCIAL_REPORT_BY_ID,
  POST_REPORT_DETAIL_INFO,
  LIST_POST_REPORT,
  SOCIAL_ACCOUNT_REPORT_HANDEL,
  AUDIT_POST_REPORT,
  POST_LIST,
  TALENT_POST_LIST,
  STATISTIC,
  POST_AUDIT,
  POST_CONTROL,
  POST_HIDDEN,
  POST_DETAIL,
  TALENT_POST_DETAIL,
  HOME_PAGE_LIST,
  MUTE_PAGE_LIST,
  HOME_PAGE_TOP,
  HOME_PAGE_DEL_TOP,
  AUDIT_DETAIL,
  GET_SIGNATURE,
  DYNAMIC_TASK,
  PUBLISH_DYNAMIC,
  PUBLISH_TALENT,
  UPDATE_DYNAMIC,
  GET_VIDEO_SNAPSHOT,
  DELETE_DYNAMIC,
  DELETE_TALENT,
  GET_RAND_VIRTUAL_ACCOUNT,
  GET_ACCOUNT_FOR_LIKE,
  QRY_ACCOUNT_FOR_DYNAMIC,
  RECIPE_LIST,
  REPLY_COMMENT_INFO,
  THUMS_UP,
  UPDATE_CONTENT_TAG_AND_SEARCH_KW,
  POST_DEL_TOP,
  POST_TOP,
  SET_RECOMMEND,
  CANCEL_RECOMMEND,
  VOTE_LIST,
  EXPORT_VOTE_LIST,
  POST_COMMENT,
  COMMENT_SHIELD,
  COMMENT_FOLD,
  COMMENT_TOP,
  GET_CHANNEL_LIST,
  GET_CC_CHANNEL_LIST,
  GET_CC_LABEL_CATEGORY_LIST,
  SET_CHANNEL_INFO,
  SET_TOPIC,
  TAG_LIST,
  DCP_TAG_LIST,
  CC_TAG_LIST,
  ADD_TAG,
  EDIT_TAG,
  DELETE_TAG,
  TOPIC_LIST,
  CIRCLE_LIST,
  UPDATE_TOPIC,
  ADD_TOPIC,
  DELETE_TOPIC,
  RECOMMEND_TOPIC,
  FOLLOW_TOPIC,
  UNFOLLLOW_TOPIC,
  QUERY_TOPIC,
  TOPIC_DETAIL,
  TOPIC_STATUS,
  APPEAL_LIST,
  APPEAL_DISPOSE,
  APPEAL_INFO,
  QRY_ACCOUNT_APPEAL_LIST,
  ACCOUNT_APPEAL_HAND,
  QRY_ACCOUNT_APPEAL_DETAIL
} from '../url';

/**
 * 账号列表查询（可调试）
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function qrySocialAccountList(data) {
  return fetch({
    url: QRY_SOCIAL_ACCOUNT_LIST,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 新增账号（其他功能调用）
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function socialAddSocialAccount(data) {
  return fetch({
    url: SOCIAL_ACCOUNT_ADD_SOCIAL_ACCOUNT,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 账号取消禁言
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function unforbiddenAccount(data, status) {
  let url = UNFORBIDDEN_ACCOUNT;
  if (!status) {
    url = FORBIDDEN_ACCOUNT;
    return fetch({
      url: url,
      method: 'POST',
      data: data,
      testerUrl: '/test/',
    });
  } else {
    return fetch({
      url: url,
      method: 'get',
      params: data,
      testerUrl: '/test/',
    });
  }
};

/**
 * 设置账号类型
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function socialSetAccountType(data) {
  return fetch({
    url: SOCIAL_ACCOUNT_SET_ACCOUNT_TYPE,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 设置大咖
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function setMaster(data, status) {
  let url = status ? REMOVE_MASTER : SET_MASTER;
  return fetch({
    url: url,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 编辑马甲账号
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function editVestAccount(data) {
  return fetch({
    url: EDIT_VEST_ACCOUNT,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 编辑马甲账号
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function setVestFansByUids(data) {
  return fetch({
    url: SET_VEST_FANS_BY_UIDS,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

function qryAccountByUid(data) {
  return fetch({
    url: QRY_ACCOUNT_BY_UID,
    method: 'get',
    params: data,
    testerUrl: '/test/',
  });
};

/**
 * 同步dcp账号
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function syncDcpAccount(data) {
    return fetch({
      url: SOCIAL_ACCOUNT_SYNC_ACCOUNT,
      method: 'get',
      params: data,
      testerUrl: '/test/',
    });
};

/**
 * 内容申诉列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function qryAppealList(data) {
  return fetch({
    url: APPEAL_LIST,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
}

/**
 * 内容申诉处理
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function appealDispose(data) {
  return fetch({
    url: APPEAL_DISPOSE,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
}

/**
 * 内容申诉详情
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function appealInfo(data) {
  return fetch({
    url: APPEAL_INFO,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
}


/**
 * 账号申诉列表查询
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function qryAccountAppealList(data) {
  return fetch({
    url: QRY_ACCOUNT_APPEAL_LIST,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
}


/**
 * 账号申诉处理
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function accountAppealHand(data) {
  return fetch({
    url: ACCOUNT_APPEAL_HAND,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
}


/**
 * 账号申诉详情
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function qryAccountAppealDetail(data) {
  return fetch({
    url: QRY_ACCOUNT_APPEAL_DETAIL,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
}

/**
 * 账号举报列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function qrySocialReportList(data) {
  return fetch({
    url: QRY_SOCIAL_REPORT_LIST,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 账号举报详情
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function qrySocialReportById(data) {
  return fetch({
    url: QRY_SOCIAL_REPORT_BY_ID,
    method: 'get',
    params: data,
    testerUrl: '/test/',
  });
};

/**
 * 动态举报详情
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function postReportDetailInfo(data) {
  return fetch({
    url: POST_REPORT_DETAIL_INFO,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 动态举报列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function listPostReport(data) {
  return fetch({
    url: LIST_POST_REPORT,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 账号举报处理
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function socialReportHandel(data) {
  return fetch({
    url: SOCIAL_ACCOUNT_REPORT_HANDEL,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 动态举报处理
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function auditPostReport(data) {
  return fetch({
    url: AUDIT_POST_REPORT,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 获取动态列表接口
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getDynamicList(data) {
  return fetch({
    url: POST_LIST,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 获取动态列表接口
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getTalentList(data) {
  return fetch({
    url: TALENT_POST_LIST,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 后台统计近三个月动态数
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getStatistic(data) {
  return fetch({
    url: STATISTIC,
    method: 'get',
    params: data,
    testerUrl: '/test/',
  });
};

/**
 * 动态审核
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function dynamicAudit(data) {
  return fetch({
    url: POST_AUDIT,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 风控设置
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function dynamicControl(data) {
  return fetch({
    url: POST_CONTROL,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 动态屏蔽
 * @param  {Object} params  表单
 * @return {Promise}      返回请求的Promise
 */
function dynamicHidden(params) {
  return fetch({
    url: POST_HIDDEN,
    method: 'get',
    params: params,
    testerUrl: '/test/',
  });
};

/**
 * 动态详情
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function dynamicDetail(data) {
  return fetch({
    url: POST_DETAIL,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 动态详情
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function talentDetail(data) {
  return fetch({
    url: TALENT_POST_DETAIL,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 个人动态列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function homePageList(data) {
  return fetch({
    url: HOME_PAGE_LIST,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 禁言记录列表
 * @param  {Object} params  表单
 * @return {Promise}      返回请求的Promise
 */
function mutePageList(data) {
  return fetch({
    url: MUTE_PAGE_LIST,
    method: 'get',
    params: data,
    testerUrl: '/test/',
  });
};

/**
 * 主页动态置顶、取消置顶
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function homePageTop(data, status) {
  let url = status ? HOME_PAGE_DEL_TOP : HOME_PAGE_TOP;
  return fetch({
    url: url,
    method: 'POST',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 审核详情
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function auditDetail(data) {
  return fetch({
    url: AUDIT_DETAIL,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 发布动态
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function dynamicTask(data) {
  return fetch({
    url: DYNAMIC_TASK,
    method: 'get',
    params: data,
    testerUrl: '/test/',
  });
};

/**
 * 发布动态
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function publishDynamic(data) {
  return fetch({
    url: PUBLISH_DYNAMIC,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 发布动态
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getSignature(data) {
  return fetch({
    url: GET_SIGNATURE,
    method: 'get',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 发布动态
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function publishTalent(data) {
  return fetch({
    url: PUBLISH_TALENT,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 编辑动态
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function updateDynamic(data) {
  return fetch({
    url: UPDATE_DYNAMIC,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 获取视频截帧
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getVideoSnapshot(data) {
  return fetch({
    url: GET_VIDEO_SNAPSHOT,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 编辑动态
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function deleteDynamic(data) {
  return fetch({
    url: DELETE_DYNAMIC,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 编辑动态
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function deleteTalent(data) {
  return fetch({
    url: DELETE_TALENT,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 获取马甲号
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getRandVirtualAccount(data) {
  return fetch({
    url: GET_RAND_VIRTUAL_ACCOUNT,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 点赞账号列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getAccountForLike(data) {
  return fetch({
    url: GET_ACCOUNT_FOR_LIKE,
    method: 'get',
    params: data,
    testerUrl: '/test/',
  });
};

/**
 * 获取官方/达人账号
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function qryAccountForDynamic(data) {
  return fetch({
    url: QRY_ACCOUNT_FOR_DYNAMIC,
    method: 'post',
    data: data,
  });
};

/**
 * 食谱列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getRecipeList(data) {
  return fetch({
    url: RECIPE_LIST,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 标签和关键词
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function updateContentTagAndSearchKW(data) {
  return fetch({
    url: UPDATE_CONTENT_TAG_AND_SEARCH_KW,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 回复评论
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function replyCommentInfo(data) {
  return fetch({
    url: REPLY_COMMENT_INFO,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 回复评论
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function thumbsUp(data) {
  return fetch({
    url: THUMS_UP,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 动态置顶、取消置顶
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function socialSetDateTime(data) {
  return fetch({
    url: POST_TOP,
    method: 'POST',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 账号取消禁言
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function setRecommend(data, status) {
  let url = status ? CANCEL_RECOMMEND : SET_RECOMMEND;
  return fetch({
    url: url,
    method: 'POST',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 投票明细
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function dynamicVoteList(data) {
  return fetch({
    url: VOTE_LIST,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 导出投票明细
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function dynamicExportVoteList(params) {
  return fetch({
    url: EXPORT_VOTE_LIST,
    method: 'get',
    params: params,
    testerUrl: '/test/',
  });
};

/**
 * 评论列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function dynamicComment(data) {
  return fetch({
    url: POST_COMMENT,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 屏蔽评论
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function commentShield(data) {
  return fetch({
    url: COMMENT_SHIELD,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 评论折叠
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function commentFold(data) {
  return fetch({
    url: COMMENT_FOLD,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 评论置顶
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function commentTop(data) {
  return fetch({
    url: COMMENT_TOP,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 频道列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getChannelList(data) {
  return fetch({
    url: GET_CHANNEL_LIST,
    method: 'get',
    params: data,
    testerUrl: '/test/',
  });
};

/**
 * 频道列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
 function getCcChannelList(data) {
  return fetch({
    url: GET_CC_CHANNEL_LIST,
    method: 'post',
    params: data,
    testerUrl: '/test/',
  });
};

/**
 * 关联频道
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function setChannelInfo(data) {
  return fetch({
    url: SET_CHANNEL_INFO,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 关联话题
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function setTopic(data) {
  return fetch({
    url: SET_TOPIC,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 获取标签列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getDcpTagList(data) {
  return fetch({
    url: DCP_TAG_LIST,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 获取标签列表（按照内容中心接口形式新增的接口）
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
 function getCcTagList(data) {
  return fetch({
    url: CC_TAG_LIST,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 获取标签分类列表（按照内容中心接口形式新增的接口）
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
 function getLabelCategorys(data) {
  return fetch({
    url: GET_CC_LABEL_CATEGORY_LIST,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 获取标签列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getTagList(data) {
  return fetch({
    url: TAG_LIST,
    method: 'post',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 新增、修改标签
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function editTag(data, status) {
  let url = status ? EDIT_TAG : ADD_TAG;
    return fetch({
      url: url,
      method: 'POST',
      data: data,
      testerUrl: '/test/',
    });
};

/**
 * 删除标签
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function deleteTag(data, status) {
  return fetch({
    url: DELETE_TAG,
    method: 'POST',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 话题列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getTopicList(data) {
  return fetch({
    url: TOPIC_LIST,
    method: 'POST',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 圈子列表
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getCircleList(data) {
  return fetch({
    url: CIRCLE_LIST,
    method: 'POST',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 更新话题 + 新增话题
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function editTopic(data, status) {
  let url = status ? UPDATE_TOPIC : ADD_TOPIC;
  return fetch({
    url: url,
    method: 'POST',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 删除话题
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function deleteTopic(data) {
  return fetch({
    url: DELETE_TOPIC,
    method: 'POST',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 删除话题
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function recommendTopic(params) {
  return fetch({
    url: RECOMMEND_TOPIC,
    method: 'POST',
    params: params,
    testerUrl: '/test/',
  });
};

/**
 * 关注话题
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function followTopic(data) {
  return fetch({
    url: FOLLOW_TOPIC,
    method: 'POST',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 取消关注话题
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function unfollowTopic(data) {
  return fetch({
    url: UNFOLLLOW_TOPIC,
    method: 'POST',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 搜索联想话题
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function queryTopic(data) {
  return fetch({
    url: QUERY_TOPIC,
    method: 'POST',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 获取话题详情
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function getTopicDetail(data) {
  return fetch({
    url: TOPIC_DETAIL,
    method: 'POST',
    data: data,
    testerUrl: '/test/',
  });
};

/**
 * 获取话题详情
 * @param  {Object} data  表单
 * @return {Promise}      返回请求的Promise
 */
function changeTopicStatus(data) {
  return fetch({
    url: TOPIC_STATUS,
    method: 'POST',
    data: data,
    testerUrl: '/test/',
  });
};

const socialContact = {
  // 账号管理
  qrySocialAccountList,
  socialAddSocialAccount,
  unforbiddenAccount,
  socialSetAccountType,
  setMaster,
  syncDcpAccount,
  editVestAccount,
  setVestFansByUids,
  qryAccountByUid,
  // 举报管理
  qryAccountAppealList,
  accountAppealHand,
  qryAccountAppealDetail,
  appealInfo,
  appealDispose,
  qryAppealList,
  qrySocialReportList,
  qrySocialReportById,
  postReportDetailInfo,
  listPostReport,
  socialReportHandel,
  auditPostReport,
  getDynamicList,
  getTalentList,
  getStatistic,
  dynamicAudit,
  dynamicControl,
  dynamicHidden,
  dynamicDetail,
  talentDetail,
  homePageList,
  mutePageList,
  homePageTop,
  getRandVirtualAccount,
  getAccountForLike,
  qryAccountForDynamic,
  getRecipeList,
  replyCommentInfo,
  thumbsUp,
  updateContentTagAndSearchKW,
  auditDetail,
  getSignature,
  dynamicTask,
  publishDynamic,
  publishTalent,
  updateDynamic,
  getVideoSnapshot,
  deleteDynamic,
  deleteTalent,
  socialSetDateTime,
  setRecommend,
  dynamicVoteList,
  dynamicExportVoteList,
  dynamicComment,
  commentShield,
  commentFold,
  commentTop,
  getChannelList,
  getCcChannelList,
  setChannelInfo,
  setTopic,
  getTagList,
  getDcpTagList,
  getCcTagList,
  getLabelCategorys,
  editTag,
  deleteTag,
  getTopicList,
  getCircleList,
  editTopic,
  deleteTopic,
  recommendTopic,
  followTopic,
  unfollowTopic,
  queryTopic,
  getTopicDetail,
  changeTopicStatus,
};

export { socialContact };
